const card = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getStoreInfo({ rootState, commit }, params = {}) {
      const data = await rootState.http("store/getStoreInfo", params);
      return data;
    },
    async getStoreInfoNoParam({ rootState, commit }, params = {}) {
      const data = await rootState.http("store/getCurrentStoreInfo", params);
      return data;
    }
  }
};

export default card;



// WEBPACK FOOTER //
// ./src/store/modules/store.js